import React, { useMemo } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../modules/login";
import styled, { withTheme } from "styled-components";
import ProfileCard from "../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../components/smart/PageHeader/PageHeader";
import SmartChangeRequestsTable from "../../components/smart/ChangeRequestsTable/ChangeRequestsTable";

const ProfileCardsWrapper = styled.div`
  margin-left: 0px;
  margin-right: 0px;
`;

const ChangeRequests = (props) => {
  const { claims, route, studies } = props;

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  return (
    <>
      <SmartPageHeader studyId={route.study} title={studyCode} />

      <ProfileCardsWrapper>
        {claims?.includes("mealLog.changeRequest.canView") && (
          <div className="mt-4">
            <ProfileCard title="Change requests" showIcon={false}>
              <SmartChangeRequestsTable />
            </ProfileCard>
          </div>
        )}
      </ProfileCardsWrapper>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(ChangeRequests));
